import { FaInstagram, FaFacebookF, FaTelegramPlane, FaTiktok } from 'react-icons/fa';
import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import Logo from '../img/mina4.jpg';

const socials = [
  { icon: FaInstagram, label: 'Instagram', href: 'https://www.instagram.com/minatechnologies?igsh=bG82ejVvYXZyNzR0' },
  { icon: FaFacebookF, label: 'Facebook', href: 'https://www.facebook.com/share/177NcABT48/' },
  { icon: FaTelegramPlane, label: 'Telegram', href: 'https://t.me/imran_hm' },
  { icon: FaTiktok, label: 'TikTok', href: '#' },
];

const links = [
  { href: '#home', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#team', label: 'Team' },
  { href: '#portfolio', label: 'Portfolio' },
  { href: '#contactus', label: 'Contact' },
];

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="glow-dark relative overflow-hidden">
      <div className="wrap relative z-10 pb-24 pt-20 sm:pb-32">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src={Logo} alt="Mina Technologies" className="h-12 w-[132px] rounded-lg object-cover ring-1 ring-white/10" />
            <p className="mt-5 max-w-sm text-subtle">
              A next-generation technology company building websites, mobile apps and digital products that help
              businesses grow.
            </p>
            <div className="mt-6 flex gap-2">
              {socials.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={label}
                  className="inline-grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white/80 transition-colors hover:border-brand hover:bg-brand hover:text-white"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <p className="eyebrow eyebrow-dark">Explore</p>
            <ul className="mt-5 space-y-2.5">
              {links.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/75 transition-colors hover:text-white">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="eyebrow eyebrow-dark">Contact</p>
            <ul className="mt-5 space-y-3 text-white/75">
              <li className="flex items-center gap-3">
                <FiMapPin className="shrink-0 text-cyan" /> Kaliti, Addis Ababa
              </li>
              <li className="flex items-center gap-3">
                <FiPhone className="shrink-0 text-cyan" />
                <a href="tel:+251927727196" className="hover:text-white">+251 927 727 196</a>
              </li>
              <li className="flex items-center gap-3">
                <FiPhone className="shrink-0 text-cyan" />
                <a href="tel:+251922313333" className="hover:text-white">+251 922 313 333</a>
              </li>
              <li className="flex items-center gap-3">
                <FiMail className="shrink-0 text-cyan" />
                <a href="mailto:info@minatechnologies.com" className="hover:text-white">info@minatechnologies.com</a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <iframe
              title="Mina Technologies location"
              className="h-48 w-full rounded-media border border-white/10 lg:h-full lg:min-h-[12rem]"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3941.5463105112794!2d38.76487527399504!3d8.921699790661435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x164b83634475d515%3A0xb32dbcddff38da0c!2sKaliti!5e0!3m2!1sen!2set!4v1720683605671!5m2!1sen!2set"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-2 border-t border-white/10 pt-6 text-sm text-subtle sm:flex-row sm:justify-between">
          <p>© {currentYear} Mina Technologies. All rights reserved.</p>
          <p>Designed &amp; developed by Mina Technologies</p>
        </div>
      </div>

      <p
        aria-hidden="true"
        className="pointer-events-none absolute -bottom-[0.3em] left-1/2 -translate-x-1/2 select-none font-display font-bold leading-none tracking-tighter text-white/[0.035]"
        style={{ fontSize: 'clamp(5rem, 18vw, 15rem)' }}
      >
        MINA
      </p>
    </footer>
  );
}

export default Footer;
